export default __webpack_public_path__ + "static/NeueHaasUnicaPro-Regular-557187c9107ac3a6919e58045f68ef14.woff2";